<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="群聊列表">
        <div class="row">
          <div class="flex xs6">
            <va-input
                v-model="nickname"
                placeholder="按用户名搜索"
                @input="search"
                removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs6">
            <va-button flat disabled color="danger">总计{{ totalCount }}条结果</va-button>
          </div>
        </div>
        <div class="flex xs12">
          <va-data-table
              :fields="fields"
              :data="groups"
              :loading="loading"
              @page-selected="listPrivateGroup"
              api-mode
              :total-pages="totalPage"
          >

            <template slot="nickname" slot-scope="props">
              <va-button color="dark" flat small :to='{path:`/admin/users/updateUser/${props.rowData.ownerAccount}`}'>
                {{ formatNickname(props.rowData.nickname) }}
              </va-button>
            </template>

            <template slot="otherNickname" slot-scope="props">
              {{ formatNickname(props.rowData.otherNickname) }}
            </template>

            <template slot="createTime" slot-scope="props">
              {{ formatTime(props.rowData.createTime) }}
            </template>

            <template slot="lastMsgTime" slot-scope="props">
              {{ formatTime(props.rowData.lastMsgTime) }}
            </template>

            <template slot="actions" slot-scope="props">
              <va-popover message="群聊列表" placement="top">
                <va-button
                    flat
                    small
                    color="gray"
                    icon="fa fa-comments-o"
                    :to="{name:'chat', params:{channelId: props.rowData.groupId}}"
                />
              </va-popover>
              <va-popover message="解散群组" placement="top">
                <va-button
                    flat
                    small
                    color="gray"
                    icon="fa fa-trash"
                    @click="deleteModal = true; deleteGroupId=props.rowData.groupId"/>
              </va-popover>
            </template>
          </va-data-table>
          <va-modal
              v-model="deleteModal"
              title="解散群组"
              okText="提交"
              position="center"
              message="请再次确认是否要解散群组？"
              @ok="confirmDestroy"
          />
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import groupApi from '../../api/group'
import {dateFormat} from '../../utils/common'
import debounce from "lodash/debounce";

export default {
  data() {
    return {
      message: ['Required field'],
      groups: [],
      loading: true,
      next: 0,
      totalCount: 0,
      deleteModal: false,
      deleteGroupId: null,
      pageNumber: 1,
      nickname: null,
      totalPage: null
    }
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:nickname',
          title: '用户',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:otherNickname',
          title: '导师',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:createTime',
          title: '创建时间',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:lastMsgTime',
          title: '上次发言时间',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
      ]
    },
  },
  created() {
    this.listPrivateGroup()
  },
  methods: {
    formatNickname(nickname) {
      if (nickname == null) {
        return ''
      }
      if (nickname.length <= 10) {
        return nickname
      } else {
        return nickname.substr(0, 10) + '...'
      }
    },
    confirmDestroy() {
      console.log(this.deleteGroupId)
      if (this.deleteGroupId == null) return
      const param = {
        groupId: this.deleteGroupId,
      }
      groupApi.destroyGroup(param)
          .then(response => {
            if (response.success === true) {
              this.listPrivateGroup()
            } else {
              this.listPrivateGroup()
            }
          })
    },
    formatMember(member) {
      if (member == null) {
        return ''
      }
      console.log(member.nickname)
      return member.nickname
    },
    formatTime(time) {
      if (time === 0) {
        return '未发言'
      }
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },
    listPrivateGroup(pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 20,
        pageNumber: pageNumber,
      }
      if (this.nickname != null) {
        data.nickname = this.nickname
      }
      groupApi.listPrivateGroup(data)
          .then(response => {
            console.log(response)
            this.groups = response.groups
            this.totalPage = response.totalPage
            this.totalCount = response.totalCount
            this.loading = false
          })
    },
    search: debounce(function (nickname) {
      this.nickname = nickname
      if (this.nickname === '') {
        this.nickname = null
      }
      this.listPrivateGroup()
    }, 400),
  },
}

</script>

<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 5%;
}
</style>
